// Company: Ajinsoft
// Author: Uilan Coqueiro
// VERSION: 2023-06-09


export function copyObject(obj: any): any {
  if (!obj)
    return null;

  return JSON.parse(JSON.stringify(obj));
}

export function hydrate<T extends object>(defaults: T, overrides: Partial<T>): T {
  const result = { ...defaults };
  for (const key of Object.keys(overrides) as (keyof T)[]) {
    const val = overrides[key];
    if (val !== null && val !== undefined) {
      result[key] = val as T[typeof key];
    }
  }
  return result;
}
